import React, { useState, useEffect, useContext, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import UserContext from "../context/UserContext";
import { login, getOtp } from "../Services/Service";
import OTPInput, { ResendOTP } from "otp-input-react";
import pentaimg from "../css/img/profilePicture1.jpg";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { BottomSheetCustom } from "@cred/neopop-web/lib/components";
import { login_begin, login_complete } from "../Services/events";

const initialValue = {
  userPhonenumber: "",
  password: "",
  username: "",
};

const BottomLogin = ({ reredirect, onClose }) => {
  const { state, updateInfo } = useContext(UserContext);
  const [OTP, setOTP] = useState("");
  const [mobile, setMobile] = useState("");
  const [registerdMobile, setRegisteredMobile] = useState("");
  const [showTimer, setShowTimer] = useState("");

  const buttonRef = useRef(null);

  // console.log(mobile)
  const myForm = useRef();
  const nav = useNavigate();
  const location = useLocation();
  // console.log(location.state);
  const [otp, setOtp] = useState("");

  const [user, setUser] = useState(initialValue);
  //  console.log(user)
  const [formErrors, setFormErrors] = useState("");
  const [otpStatus, setOtpStatus] = useState("");
  const [disabled, setDisabled] = useState(false);
  const [time, setTime] = useState(false);
  const [isOtp, setIsOtp] = useState(false);
  // console.log(otpStatus)

  const [alertInfo, setAlertInfo] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const [alertInfos, setAlertInfos] = useState({
    visible: false,
    cls: "",
    msg: "",
  });
  const onShowAlert = (msg, visible, clas) => {
    setAlertInfo({
      ...alertInfo,
      ["visible"]: visible,
      ["cls"]: clas,
      ["msg"]: msg,
    });
  };

  const onValueChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
  };

  const handleClick = (e) => {
    // console.log(e.target.name)
    myForm.current = e.target.name;
  };
  function validateForm(e) {
    if (e === true || e?.target.name === "Send_OTP") {
      if (mobile.length !== 10) {
        // console.log(mobile)
        setFormErrors("Please Enter 10 digit Mobile No.");
        return false;
      } else {
        // console.log(mobile)
        setFormErrors("");
        return true;
      }
    } else {
      if (OTP.length !== 6) {
        setFormErrors("");
        setFormErrors("Please Enter 6 digit OTP");
        return false;
      } else {
        setFormErrors("");
        return true;
      }
    }
  }

  const verifyOtp = async () => {
    try {
      const response = await login(registerdMobile, OTP);
      await login_complete();

      const {
        status,
        msg: message,
        auth,
        redirect,
      } = response?.data?.data || {};

      if (status === 1) {
        // Save auth token and update UI state
        localStorage.setItem("auth", auth);
        setOtpStatus(1);
        updateInfo();
        onClose();
        setIsOtp(false);

        // Show success alert
        onShowAlert(message, true, "success");

        // Redirect based on API response
        if (redirect === "/register") {
          nav("/register", {
            state: {
              redirect: redirect,
              reredirect: location.pathname,
            },
          });
        } else {
          nav("/congratulations", {
            state: { redirect: location.pathname },
          });
        }
      } else {
        // Show failure alert with message from API
        showErrorAlert(message);
      }
    } catch (error) {
      console.error("Login failed", error);
      showErrorAlert("Login failed. Please try again.");
    }
  };

  // Helper function to show error alert
  const showErrorAlert = (message) => {
    setAlertInfo({
      ...alertInfo,
      visible: true,
      cls: "danger",
      msg: message,
    });
    setIsOtp(false);
  };

  const submitHandle = async (e) => {
    if (e.preventDefault) {
      e.preventDefault();
    }

    const isSendOtpFlow = e === true || e?.target.name === "Send_OTP";

    if (isSendOtpFlow) {
      let isvalidForm = validateForm(e);
      login_begin();

      if (isvalidForm) {
        setTime(true);

        await getOtp(mobile)
          .then((response) => {
            const status = response.data.data?.status;
            const message = response.data.data?.msg;

            if (status === 1) {
              setRegisteredMobile(response.data.data?.registerdMobile);
              setDisabled(true);

              let i = 20;
              const timerId = setInterval(() => {
                setAlertInfo({
                  ...alertInfo,
                  visible: true,
                  cls: "success",
                  msg: `${message}`,
                });
                setShowTimer(`Resend in ${i--}s`);
              }, 1000);

              setTimeout(() => {
                clearInterval(timerId);
                setAlertInfo({
                  ...alertInfo,
                  visible: true,
                  cls: "success",
                  msg: message,
                });
                setShowTimer(``);
                setTime(false);
              }, 20000);
            } else {
              setAlertInfo({
                ...alertInfo,
                visible: true,
                cls: "danger",
                msg: message,
              });
            }
          })
          .catch((error) => {
            console.error("OTP request failed", error);
            setAlertInfo({
              ...alertInfo,
              visible: true,
              cls: "danger",
              msg: "Failed to get OTP. Please try again later.",
            });
          });

        // Begin SMS auto-read
        const signal = new AbortController();
        setTimeout(() => {
          signal.abort();
        }, 1 * 60 * 1000);

        async function main() {
          if ("OTPCredential" in window && navigator.credentials) {
            try {
              const content = await navigator.credentials.get({
                abort: signal,
                otp: { transport: ["sms"] },
              });
              if (content && content.code) {
                alert(content.code);
              }
            } catch (err) {
              console.log(err);
            }
          }
        }

        main();
      }
    }
  };

  const renderButton = (buttonProps) => {
    // console.log(buttonProps)
    return (
      <span>
        {buttonProps.remainingTime !== 0
          ? `Please wait for ${buttonProps.remainingTime} sec`
          : ""}
      </span>
    );
  };
  const renderTime = (remainingTime) => {
    return React.Fragment;
  };
  console.log(showTimer, "showTimer");

  return (
    <>
      <div className="container">
        {!disabled ? (
          <div className="login-penta bg-common mb-5">
            <div className="row align-items-center">
              {/* <div className="col-md-5 d-none d-md-block">
                   <img className='img-fluid' src={pentaimg} alt="" />
               </div> */}
              <div className="">
                <div className="login-content text-center">
                  <h1 className="my-2 fs-2">Welcome to IceSpice</h1>
                  <p className="text-white-30 ">
                    Please enter 10 digit mobile number, login and unlock
                    awesome discount
                  </p>
                  <div className="form-penta position-relative mt-5">
                    <span className="position-absolute">+91</span>
                    <input
                      type="number"
                      inputMode="numeric"
                      className="form_control"
                      name="mobileNumber"
                      id="mobileNumber"
                      placeholder="Enter mobile number"
                      value={mobile}
                      onChange={(e) => {
                        if (e.target.value?.length <= 10) {
                          setMobile(e.target.value);
                        }
                      }}
                      autoComplete="off"
                      maxLength={10}
                      autoFocus={true}
                    />
                  </div>
                  {mobile?.length < 10 && mobile?.length !== 0 ? (
                    <span style={{ fontSize: "10px", color: "red" }}>
                      Please Enter 10 digits mobile number
                    </span>
                  ) : (
                    ""
                  )}

                  <div className="signNwTxtInfo">
                    <div className="signUpTxt" style={{ color: "red" }}>
                      {alertInfos.msg}
                    </div>
                  </div>

                  <p className="my-4 mb-100 small text-white-50">
                    By continuing, you agree to our <Link>Terms of Use</Link>{" "}
                    and <Link>Privacy Policy</Link>{" "}
                  </p>
                  <button
                    type="button"
                    name="Send_OTP"
                    className="btnPrimary"
                    disabled={mobile.length === 10 ? false : true}
                    onClick={(e) => submitHandle(e)}
                  >
                    Continue
                  </button>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="login-penta bg-common">
            <div className="headSec">
              {/* <h2 style={{marginBottom:"10px"}}>Welcome</h2> */}
              {/* <p>OTP sent to registered number on +91 {mobile}</p> */}
              {/* <p className="text-white-30 ">awesome discount</p> */}
            </div>
            <div className="otpFormSec">
              <div className="signNwTxtInfo d-flex justify-content-center">
                <div style={{ fontSize: "15px" }}>{alertInfo.msg}</div>
              </div>

              <div className=" d-flex justify-content-center">
                <div className="mb-4">{showTimer}</div>
              </div>
              <OTPInput
                value={OTP}
                onChange={setOTP}
                autoFocus
                OTPLength={6}
                autocomplete="one-time-code"
                otpType="number"
                disabled={false}
                className="otpinputs justify-content-center"
              />
              {/* <OTPInput defaultValue={"111111"} value={"111111"} 
  onChange={setOTP} autoFocus OTPLength={6} autocomplete="one-time-code" otpType="number" disabled={false} className="otpinputs"/> */}
              <div className="d-flex justify-content-between ">
                <div className="">
                  <button
                    type="button"
                    className="btnLink"
                    onClick={() => {
                      setAlertInfos({
                        ...alertInfo,
                        visible: false,
                        cls: "success",
                        msg: ``,
                      });
                      setDisabled(false);
                    }}
                  >
                    Edit Number
                  </button>
                </div>
                <div className="">
                  <button
                    disabled={time}
                    type="button"
                    name="Send_OTP"
                    className="btnLink"
                    onClick={(e) => submitHandle(e)}
                  >
                    Resend OTP
                    {/* <ResendOTP className="btnLink" onResendClick={e => submitHandle(e)} renderButton={renderButton} renderTime={renderTime} maxTime={20}/> */}
                  </button>
                </div>
              </div>
            </div>
            <div className="actSec mt-30 mb-100">
              <button
                type="button"
                className="btnPrimary"
                id="validOtp"
                disabled={OTP.length === 6 ? false : true}
                onClick={(e) => {
                  verifyOtp(e);
                  setIsOtp(true);
                }}
                style={{ width: "80%" }}
              >
                Continue
              </button>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default BottomLogin;
